var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",class:['tkPulldown', { '-disabled': _vm.disabled }],style:(_vm.styleVars)},[(_vm.hasCustomMenu)?[_c('button',{class:[
        'tkPulldown_pulldown',
        '-customMenu',
        `-${_vm.iconPosition}`,
        `-${_vm.theme}`,
        `-${_vm.textColor}`,
        { '-putTextIconOutside': _vm.putTextIconOutside },
        { '-noIcon': !_vm.iconName },
        { '-noBorder': _vm.noBorder },
        { '-bold': _vm.bold },
        { '-active': _vm.active },
      ],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){_vm.isMenuOpen = !_vm.isMenuOpen}}},[_vm._v(" "+_vm._s(_vm.selectedLabel)+" ")]),(_vm.isMenuOpen)?_c('ul',{staticClass:"tkPulldown_menu",style:({ maxHeight: `${_vm.menuMaxItems * _vm.MENU_ITEM_HEIGHT}px` })},[(_vm.unselectedLabel)?_c('li',{class:['tkPulldown_menuItem', { '-selected': _vm.selectedValue === 'unselected-value' }],on:{"click":function($event){return _vm.selectItem('')}}},[_vm._v(" "+_vm._s(_vm.unselectedLabel)+" ")]):_vm._e(),_vm._l((_vm.items),function(item){return _c('li',{key:item.value,class:['tkPulldown_menuItem', { '-selected': String(item.value) === String(_vm.selectedValue) }],on:{"click":function($event){return _vm.selectItem(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])})],2):_vm._e()]:_c('select',{class:[
      'tkPulldown_pulldown',
      `-${_vm.iconPosition}`,
      `-${_vm.theme}`,
      `-${_vm.textColor}`,
      { '-putTextIconOutside': _vm.putTextIconOutside },
      { '-noIcon': !_vm.iconName },
      { '-noBorder': _vm.noBorder },
      { '-bold': _vm.bold },
      { '-active': _vm.active },
    ],attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.selectedValue},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}},[(_vm.unselectedLabel)?_c('option',{staticClass:"tkPulldown_unselectedOption",attrs:{"value":"unselected-value"}},[_vm._v(" "+_vm._s(_vm.unselectedLabel)+" ")]):_vm._e(),_vm._l((_vm.items),function(item){return _c('option',{key:item.value,class:[
        'tkPulldown_option',
        `-${_vm.theme}`,
      ],domProps:{"value":item.value}},[_vm._v(" "+_vm._s(item.label)+" ")])})],2),(!!_vm.iconName)?_c('tk-icon',{class:[
      'tkPulldown_icon',
      `-${_vm.iconPosition}`,
      { '-putTextIconOutside': _vm.putTextIconOutside },
      _vm.icon ? `-${_vm.icon}` : '',
    ],attrs:{"name":_vm.iconName,"color":_vm.computedIconColor}}):_vm._e(),(_vm.textIcon)?_c('tk-icon',{class:[
      'tkPulldown_textIcon',
      { '-putTextIconOutside': _vm.putTextIconOutside },
    ],attrs:{"name":_vm.textIcon,"color":_vm.textIconColor}}):_vm._e(),(_vm.textIconSeparator)?_c('div',{class:['tkPulldown_separator', `-${_vm.textIconSeparator}`]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }